import {
  Box,
  CircularProgress,
  FormControl,
  InputAdornment,
  Modal,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import CampaignIcon from "@mui/icons-material/Campaign";
import { useAnnouncements } from "./useAnnouncements";
import { useCallback, useEffect, useState, useMemo } from "react";
import CloseIcon from "@mui/icons-material/Close";

export const Announcements = () => {
  const [data, setData] = useState([]);
  const [open, setOpen] = useState(false);
  const {
    anouncements,
    anouncementsLoading,
    handleGetAnnouncement,
    setAnouncementContent,
    anouncementContentLoading,
    anouncementContent,
  } = useAnnouncements();

  const htmlContent = useMemo(() => {
    return `
  <!DOCTYPE html>
  <html>
    <head>
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <style>
        img { max-width: 100%; height: auto; object-fit: contain; }
      </style>
    </head>
    <body>
   <div style="display: grid; place-items: center; width: 100%; min-height: 100%;">
       ${
         anouncementContent?.content ||
         `<h1 style="text-align: center; display: inline-block; width: 100%;;">
        Sem conteúdo disponível
      </h1>`
       }
       <div>
    </body>
  </html>
`;
  }, [anouncementContent?.content]);

  const handleSearch = useCallback(
    (event) => {
      const searchTerm = event.target.value.toLowerCase();
      const filteredAnnouncements = anouncements.filter(
        (announcement) =>
          announcement.title.toLowerCase().includes(searchTerm) ||
          announcement.subject.toLowerCase().includes(searchTerm)
      );

      setData(filteredAnnouncements);
    },
    [anouncements]
  );

  const handleOpen = useCallback(
    ({ announcement }) => {
      setOpen(true);
      handleGetAnnouncement({
        selectedAnnoucements: announcement.id,
        title: announcement.title,
      });
    },
    [handleGetAnnouncement]
  );

  const handleClose = useCallback(() => {
    setOpen(false);
    setAnouncementContent([]);
  }, [setAnouncementContent]);

  useEffect(() => {
    setData(anouncements);
  }, [anouncements]);

  return (
    <Box width="100%">
      <Typography component="h1" fontSize={25} fontWeight="bold">
        Comunicados
      </Typography>

      {anouncementsLoading ? (
        <Box
          display="flex"
          justifyContent="center"
          minHeight="80vh"
          alignItems="center"
        >
          <CircularProgress />
        </Box>
      ) : (
        <>
          {data?.length > 0 && (
            <FormControl
              variant="outlined"
              sx={{ marginTop: 2, width: "100%" }}
            >
              <TextField
                id="search-input"
                variant="outlined"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}
                width="100%"
                sx={{ marginBottom: 2 }}
                onChange={handleSearch}
              />

              {data.map((announcement) => (
                <Paper
                  component="button"
                  sx={{
                    border: "none",
                  }}
                  onClick={() => {
                    handleOpen({
                      announcement: announcement,
                    });
                  }}
                >
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    p={2}
                    sx={{
                      "&:hover": {
                        opacity: 0.5,
                      },
                    }}
                  >
                    <Box display="flex" alignItems="center">
                      <CampaignIcon
                        sx={{
                          backgroundColor: "primary.main",
                          borderRadius: "50%",
                          color: "common.white",
                          padding: 1,
                          width: 40,
                          height: 40,
                          marginRight: 2,
                        }}
                      />

                      <Box>
                        <Typography
                          fontSize={20}
                          fontWeight="bold"
                          textAlign="start"
                        >
                          {announcement.title}
                        </Typography>
                        <Typography fontSize={20}>
                          {announcement.publication}
                        </Typography>
                      </Box>
                    </Box>
                    <Box bgcolor="primary.light" p={1} borderRadius="20px">
                      <Typography fontSize={15} color="common.black">
                        {announcement.subject}
                      </Typography>
                    </Box>
                  </Box>
                </Paper>
              ))}
            </FormControl>
          )}

          {data?.length === 0 && !anouncementsLoading && (
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              minHeight="20vh"
            >
              <Typography component="h1" fontSize={20} fontWeight="bold">
                Nenhum comunicado encontrado
              </Typography>
            </Box>
          )}
        </>
      )}

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          position="absolute"
          top="50%"
          left="50%"
          bgcolor="background.paper"
          p={4}
          borderRadius={2}
          maxHeight={"80vh"}
          minWidth="50vw"
          overflowY="auto"
          width="90vw"
          sx={{
            transform: "translate(-50%, -50%)",
          }}
        >
          {anouncementContentLoading ? (
            <Box
              display="flex"
              justifyContent="center"
              minHeight="50vh"
              minWidth="40vw"
              alignItems="center"
            >
              <CircularProgress />
            </Box>
          ) : (
            <Box>
              <Box display="flex" justifyContent="space-between" mb={2}>
                <Typography
                  component="h2"
                  fontSize={25}
                  fontWeight="bold"
                  mb={2}
                >
                  {anouncementContent?.title}
                </Typography>
                <CloseIcon
                  sx={{ cursor: "pointer" }}
                  onClick={handleClose}
                  fontSize="large"
                />
              </Box>
              <Box dangerouslySetInnerHTML={{ __html: htmlContent }} />
            </Box>
          )}
        </Box>
      </Modal>
    </Box>
  );
};
